import CityPageTemplate from "../city-template/CityPageTemplate";
import { sacramentoConfig } from "./data";

export default function SacramentoPage() {
  return <CityPageTemplate config={sacramentoConfig} />;
}